<div class="all">
  <div class="circles">
    @switch (valueOptionSelected.value){
      @case('green') {
        <div class="circle verde"></div>
      }
      @case('red') {
        <div class="circle vermelho"></div>
      }
      @case('blue') {
        <div class="circle azul"></div>
      }
      @case('yellow') {
        <div class="circle amarelo"></div>
      }
      @case('pink') {
        <div class="circle rosa"></div>
      }
      @case('purple') {
        <div class="circle roxo"></div>
      }
      @case('orange') {
        <div class="circle laranja"></div>
      }
    }

  </div>
  <tgt-select
    [options]="optionsColor"
    [valueOptionSelected]="valueOptionSelected"
    [label]="label"
    [control]="control"
    [icon]="icon"
    [size]="size"
    [border]="border"
    [background]="background"
    [borderRadios]="borderRadios"
    [error]="error"
    (changeOption)="optionSelect($event)"
  ></tgt-select>
</div>

